import { Modal } from "antd";
import styled from "@emotion/styled";

export const ModalDeleteStyle = styled(Modal)``